if(window.innerWidth < 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    let buttonMenu = document.querySelector('.nav-main_icon')
    menuItems.forEach(function(item) {
        item.addEventListener('click',function(){
            let activeItem = document.querySelector('.nav-main-item.active')
            this.classList.toggle('active')
            if(activeItem){
                activeItem.classList.remove('active')
            }
        })
    })
    buttonMenu.addEventListener('click',function(){
        let menuPosition = document.querySelector('#nav-main')
        menuPosition.classList.toggle('menuposition')
    })
}
if(window.innerWidth >= 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    menuItems.forEach(function(item) {
        let menuPosition = document.querySelector('#nav-main')
        item.addEventListener('mouseenter',function(){
            this.classList.toggle('active')
        })
        item.addEventListener('mouseleave',function(){
            this.classList.remove('active')
        })
    })
}
